import { defineFetch } from 'resift';

export default defineFetch({
  displayName: 'Delete Entity',
  make: () => ({
    request: (entityId: string) => ({ http }) =>
      http({
        method: 'DELETE',
        route: `/entities/${entityId}`,
      }),
  }),
});
